var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import domReady from '@roots/sage/client/dom-ready';
import './registerAbode';
import { stickyHeader } from './utils/stickyHeader';
domReady(function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        initMobileMenu();
        initNavOverlay();
        initPrimaryNav();
        stickyHeader();
        return [2 /*return*/];
    });
}); });
function initNavOverlay() {
    var toggleButton = document.getElementById('nav-toggle');
    var overlay = document.getElementById('popover-menu');
    var body = document.body;
    if (!toggleButton || !overlay) {
        return;
    }
    var backdrop = overlay.querySelector('.nav-overlay__backdrop');
    toggleButton.addEventListener('click', function () {
        if (overlay.classList.contains('is-open')) {
            closeMenu(toggleButton, overlay, body);
            return;
        }
        openMenu(toggleButton, overlay, body);
    });
    backdrop === null || backdrop === void 0 ? void 0 : backdrop.addEventListener('click', function () {
        closeMenu(toggleButton, overlay, body);
    });
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
            closeMenu(toggleButton, overlay, body);
        }
    });
    overlay.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
            closeMenu(toggleButton, overlay, body);
        });
    });
}
function initPrimaryNav() {
    var nav = document.querySelector('.nav-primary');
    if (!nav) {
        return;
    }
    nav.querySelectorAll('.menu-item-has-children').forEach(function (item) {
        var toggle = item.querySelector(':scope > .nav-primary__toggle');
        if (!toggle) {
            return;
        }
        toggle.addEventListener('click', function () {
            var willOpen = !item.classList.contains('is-open');
            nav.querySelectorAll('.menu-item-has-children.is-open').forEach(function (openItem) {
                var _a;
                if (openItem === item) {
                    return;
                }
                openItem.classList.remove('is-open');
                (_a = openItem
                    .querySelector(':scope > .nav-primary__toggle')) === null || _a === void 0 ? void 0 : _a.setAttribute('aria-expanded', 'false');
            });
            item.classList.toggle('is-open', willOpen);
            toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        });
    });
}
function initMobileMenu() {
    var toggleButton = document.getElementById('mobile-menu-toggle');
    var overlay = document.getElementById('mobile-menu-overlay');
    var body = document.body;
    if (!toggleButton || !overlay)
        return;
    toggleButton.addEventListener('click', function () {
        var isOpen = overlay.classList.contains('is-open');
        if (isOpen) {
            closeMenu(toggleButton, overlay, body);
        }
        else {
            openMenu(toggleButton, overlay, body);
        }
    });
    overlay.addEventListener('click', function (e) {
        if (e.target === overlay) {
            closeMenu(toggleButton, overlay, body);
        }
    });
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
            closeMenu(toggleButton, overlay, body);
        }
    });
    overlay.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
            closeMenu(toggleButton, overlay, body);
        });
    });
}
function openMenu(toggleButton, overlay, body) {
    overlay.classList.add('is-open');
    toggleButton.setAttribute('aria-expanded', 'true');
    overlay.setAttribute('aria-hidden', 'false');
    body.style.overflow = 'hidden';
}
function closeMenu(toggleButton, overlay, body) {
    overlay.classList.remove('is-open');
    toggleButton.setAttribute('aria-expanded', 'false');
    overlay.setAttribute('aria-hidden', 'true');
    body.style.overflow = '';
}
// @ts-expect-error TS2339: Property webpackHot does not exist on type ImportMeta
if (import.meta.webpackHot)
    import.meta.webpackHot.accept(console.error); // eslint-disable-line no-console
